import { useState } from "react";
import { Menu, X, LogOut } from "lucide-react";
import { BrandMark } from "@/components/brand/BrandMark";
import { useAuth } from "@/lib/auth/AuthContext";
import { Drawer } from "@/components/ui/Drawer";
import { NavList } from "./NavList";

export function MobileNav() {
  const [open, setOpen] = useState(false);
  const { state, logout } = useAuth();
  const email = state.status === "authenticated" ? state.user.email : "";

  return (
    <>
      <header className="flex h-14 items-center gap-3 border-b border-ink/10 bg-brand-900 px-4 md:hidden">
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Abrir menu de navegacion"
          className="flex h-11 w-11 items-center justify-center rounded-lg text-white hover:bg-brand-800/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
        >
          <Menu className="h-5 w-5" aria-hidden="true" />
        </button>
        <div className="flex items-center gap-2">
          <BrandMark className="h-6 w-6 text-brand-200" />
          <p className="text-sm font-semibold text-white">Shalom App Control</p>
        </div>
      </header>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title="Navegacion"
        side="left"
        hideHeader
        panelClassName="max-w-[280px] bg-brand-900"
      >
        <div className="-mx-5 -my-4 flex h-[calc(100%+2rem)] flex-col">
          <div className="flex h-14 items-center justify-between px-5">
            <div className="flex items-center gap-2">
              <BrandMark className="h-6 w-6 text-brand-200" />
              <p className="text-sm font-semibold text-white">Shalom App Control</p>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Cerrar menu"
              className="flex h-11 w-11 items-center justify-center rounded-lg text-white hover:bg-brand-800/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
            >
              <X className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto py-3">
            <NavList onNavigate={() => setOpen(false)} />
          </div>
          <div className="border-t border-white/10 px-3 py-3">
            <div className="mb-2 truncate px-3 text-xs text-brand-300">{email}</div>
            <button
              type="button"
              onClick={() => void logout()}
              className="flex min-h-11 w-full items-center gap-3 rounded-lg px-3 py-3 text-sm font-medium text-white/85 hover:bg-brand-800/60 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-900"
            >
              <LogOut className="h-[1.125rem] w-[1.125rem]" aria-hidden="true" />
              Cerrar sesion
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
}
